import ArticleIcon from '@mui/icons-material/Article';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import BorderInnerIcon from '@mui/icons-material/BorderInner';
import DataObjectIcon from '@mui/icons-material/DataObject';
import DownloadIcon from '@mui/icons-material/Download';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Button,List,ListItem,Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import AttToken from '../../../helpers/attToken';
import Files from '../../../service/Files';


const filesService = new Files();

export default function ListaArquivos({ files }: { files: { nome: string, type: string, path: string }[] }) {

  const getFilesV2 = async (path: string, nome: string) => {
    const response = toast.promise(async () => {
      const token = await AttToken();
      if (token) {
        const response = await filesService.downloadFiles(token, 'web', '-', [path]);
        if (!response) throw new Error('No response from server');
        if (response) {
          const blob = await fetch(response.urls[0]).then(res => res.blob());
          const file = URL.createObjectURL(blob);
          if (file) {
            const a = document.createElement("a");
            a.href = await file;
            a.download = nome;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        }
      }
    }, {
      pending: 'Baixando arquivo...',
      success: 'Arquivo baixado',
      error: 'Erro ao baixar arquivo'
    });
    return response;

  };

  const getFileType = (value: string) => {
    const fileName = value?.substring(value.lastIndexOf('.') + 1);
    switch (fileName) {
      case 'png': case 'jpg': case 'jpeg': case 'gif': case 'bmp': case 'svg': case 'webp': case 'tiff': case 'heic':
        return (<ImageIcon />);
      case 'pdf':
        return (<PictureAsPdfIcon />);
      case 'doc': case 'docx': case 'txt': case 'ppt': case 'pptx':
        return (<ArticleIcon />);
      case 'xls': case 'xlsx': case 'csv':
        return (<BorderInnerIcon />);
      case 'json':
        return (<DataObjectIcon />);
      case 'audio': case 'mp3':
        return (<AudioFileIcon />);
      case 'video': case 'mp4':
        return (<VideoFileIcon />);
      default: return (<ArticleIcon />);
    }
  };

  function truncateFileName(name: string, maxLength = 20) {
    if (name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf('.');
    const ext = extIndex !== -1 ? name.substring(extIndex) : '';
    const base = name.substring(0, maxLength - ext.length - 3);
    return `${base}...${ext}`;
  };

  return (
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      {files.map((ele, ind) => (
        <Tooltip key={ind} title={ele.nome}>
          <ListItem >
            <Button
              startIcon={getFileType(ele.nome)}
              endIcon={<DownloadIcon />}
              variant='outlined'
              sx={{ textTransform: 'none', width: '100%', justifyContent: 'space-between' }}
              disabled={window.location.pathname.includes('detalhe-checklist')}
              size='small'
              onClick={() => getFilesV2(ele.path, ele.nome)}>
              {truncateFileName(ele?.nome)}
            </Button>
          </ListItem>
        </Tooltip>
      ))
      }
    </List >
  );
}
